import { render, staticRenderFns } from "./product-details-channels.vue?vue&type=template&id=8b8619f8&scoped=true&"
import script from "./product-details-channels.vue?vue&type=script&lang=js&"
export * from "./product-details-channels.vue?vue&type=script&lang=js&"
import style0 from "./product-details-channels.vue?vue&type=style&index=0&id=8b8619f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b8619f8",
  null
  
)

export default component.exports